import React, { useEffect, useRef, useState } from "react";
import StyledText from "../../components/StyledComponents/StyledText";
import ArrowIcon from "../../assets/icons/ArrowIcon";
import { Container } from "../../components/listing/AMSListing";
import Breadcrumb from "../../components/BreadCrumbs/Breadcrumbs";
import styled from "styled-components";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Tabs } from "../../components/Tabs/Tabs";
import { getActiveTabId, handleChangeTab, Tab } from "../../utils/helper";

import OrganizationOverview from "./OrganizationOverview/OrganizationOverview";
import { SkeletonCell } from "../../components/SkeletonCell";
import { useTheme } from "../../middleware/ThemeContext";
import {
  useDeleteOrganizationMutation,
  useGetMultipleOrgRecordsQuery,
  usePresignedOrganizationProfileMutation,
  useUpdateOrganizationMutation,
} from "../../api/organizationApiSlice";
import { useToast } from "../../components/toast/ToastContext";
import OrganizationHeader from "./OrganizationHeader";
import { useGetContactAllWidgetsQuery } from "../../api/contactApiSlice";
import { LayoutWidget } from "../contacts/ContactOverview/DND/dndTypes";
import { useGetOrgDetailsQuery, useReorderLayoutMutation } from "../../api/widgetApiSlice";
import { Button } from "../../components/form/Button";
import { LoadingSpinner } from "../ui/LoadingSpinner";
import WidgetIcon from "../../assets/icons/WidgetIcon";
import CloseIcon from "../../assets/icons/CloseIcon";
import { GridStackHandle } from "../contacts/ContactOverview/DND/GridStackExample";
import NoData from "../../components/listing/NoData";
import BulkUpdateModal from "../searchQuery/BulkUpdateModal";
import PlusIcon from "../../assets/icons/PlusIcon";
import AboutOrgModal from "../../components/Modals/AboutOrgModal";
import DeleteIcon from "../../assets/icons/DeleteIcon";
import DeletePrompt from "../../components/DeletePrompt";
import PendingJoinRequests from "./PendingJoinRequests";

const OrganizationPreview = () => {
  const { theme } = useTheme();
  const { id } = useParams();
  const location = useLocation();
  const scopeFromQuery = new URLSearchParams(location.search).get("scope");
  const scope = location?.state?.scope || scopeFromQuery || "organization";
  const isPendingJoinRequestsRoute = location.pathname.includes("pending-join-requests");
  const from = new URLSearchParams(location.search).get("from") ?? location.state?.from;
  const [showOrgDeletePopup, setShowOrgDeletePopup] = useState(false);
  const param = useParams();
  const [isManagingLayout, setIsManagingLayout] = useState(false);
  const gridRef = useRef<GridStackHandle>(null);

  const {
    data,
    isLoading: loading,
    isFetching,
    refetch,
  } = useGetMultipleOrgRecordsQuery(id);
  const {
    data: widgetData,
    refetch: widgetRefetch,
    isLoading: widgetLoading,
    isFetching: widgetFetching,
  } = useGetContactAllWidgetsQuery(
    { id, scope },
    {
      skip: !id || isPendingJoinRequestsRoute,
      refetchOnMountOrArgChange: true,
      refetchOnFocus: true,
    }
  );
  const [reorder, { isLoading: reorderLoading }] = useReorderLayoutMutation();
  const [deleteOrganization] = useDeleteOrganizationMutation();
  const [showBulkUpdateModal, setShowBulkUpdateModal] = useState(false);
  const payload = {
    recordIds: id ? [Number(id)] : [],
    scope: scope || "organization",
    fieldsAccessKeys: ["organization_website", "organization_email", "organization_industry", "organization_region", "organization_number_of_employees"]

  }
  const { data: organizationData, refetch: organizationRefetch } = useGetOrgDetailsQuery(payload);
  const [showAboutOrgModal, setShowAboutOrgModal] = useState(false);

  const handleCloseAboutOrgModal = () => {
    setShowAboutOrgModal(false);
  };
  const [imagePreSignedUrl, { isLoading }] =
    usePresignedOrganizationProfileMutation();
  const organization: Organization = data ? data[0] : [];
  const [originalWidgets, setOriginalWidgets] = useState<any[]>([]);

  const [editName, seteditName] = useState(false);
  const [organizationName, setOrganizationName] = useState<string>();
  const [imageKey, setImageKey] = useState<string>();
  const [updateOrganizationName, { isLoading: isLoadingName }] =
    useUpdateOrganizationMutation();
  const showToast = useToast();
  const breadcrumbItems = [
    { label: "Organization Listing", href: "/home/organizations" },
    { label: "Organization Overview", active: true },
  ];

  const productTabs = [
    {
      id: 1,
      title: "Organization Overview",
      active: true,
    },
    {
      id: 2,
      title: "Join Requests",
      active: false,
    },
  ];

  const [tabs, setTabs] = useState<Tab[]>(productTabs);

  const [widget, setWidget] = useState<LayoutWidget[]>([]);
  // useEffect(() => {
  //   if (widgetData?.widgets?.length > 0) {
  //     setWidget(widgetData.widgets);
  //   }
  // }, [widgetData?.widgets]);
  useEffect(() => {
    if (widgetData?.widgets?.length > 0) {
      setWidget(widgetData.widgets);
      // 🔥 Jab data load ho to backup bhi save karein
      if (!isManagingLayout) {
        setOriginalWidgets(widgetData.widgets);
      }
    }
  }, [widgetData?.widgets, isManagingLayout]);

  useEffect(() => {
    refetch();
    if (!isPendingJoinRequestsRoute) {
      widgetRefetch();
    }
  }, [id, isPendingJoinRequestsRoute]);

  useEffect(() => {
    if (organization) {
      setOrganizationName(organization?.name);
    }
  }, [organization]);

  const updateName = (imageKey?: string) => {
    const value = {
      id: param?.id,
      organizationMeta: {
        ...(organizationName ? { name: organizationName } : {}),
        ...(imageKey ? { image: imageKey } : {}),
      },
    };
    updateOrganizationName(value)
      .unwrap()
      .then((res) => {
        showToast("Successfully", "Updated successfully", "success");
        seteditName(false);
        refetch && refetch();
      })
      .catch((err) => {
        showToast(
          "Error",
          err?.data?.message || "Failed to update name",
          "error"
        );
      });
  };


  // Update only organization name
  const updateOrganizationNameOnly = () => {
    if (!organizationName) return;
    const value = {
      id: param?.id,
      organizationMeta: { name: organizationName },
    };
    updateOrganizationName(value)
      .unwrap()
      .then((res) => {
        showToast("Successfully", "Updated successfully", "success");
        seteditName(false);
        refetch && refetch();
      })
      .catch((err) => {
        showToast("Error", err?.data?.message || "Failed to update name", "error");
      });
  };

  // Update only image
  const updateOrganizationImageOnly = (imageKey?: string) => {
    const value = {
      id: param?.id,
      organizationMeta: { image: imageKey },
    };
    updateOrganizationName(value)
      .unwrap()
      .then((res) => {
        showToast("Successfully", "Image updated successfully", "success");
        refetch && refetch();
      })
      .catch((err) => {
        showToast("Error", err?.data?.message || "Failed to update image", "error");
      });
  };

  const onChangeTabs = (tab: number) => {
    const updatedTabs = handleChangeTab(tabs, tab);
    setTabs(updatedTabs);
    const query = scope ? `?scope=${encodeURIComponent(scope)}` : "";
    const navState = { ...(location.state || {}), scope };

    if (tab === 1) {
      navigate(`/home/organizations/${id}${query}`, { state: navState });
    } else if (tab === 2) {
      navigate(`/home/organizations/${id}/pending-join-requests${query}`, { state: navState });
    } else {
      navigate(`/home/organizations/${id}`, { state: navState });
    }
  };

  useEffect(() => {
    if (location.pathname.includes("pending-join-requests")) {
      setTabs((prevTabs) => handleChangeTab(prevTabs, 2));
    } else if (location.pathname.endsWith(id?.toString() ?? "")) {
      setTabs((prevTabs) => handleChangeTab(prevTabs, 1));
    } else if (!location.pathname.endsWith(id?.toString() ?? "")) {
      navigate(`/home/organizations/${id}`, { replace: true });
    }

  }, [location?.pathname]);

  const activeTab = getActiveTabId(tabs);

  const navigate = useNavigate();
  const theLocation = useLocation();
  type Organization = {
    id: number;
    signedUrl?: string;
    account?: {
      firstName?: string;
      lastName?: string;
    };
    createdBy?: {
      firstName?: string;
      lastName?: string;
    };
    name?: string;
    website?: string;
    industry?: string;
    employeeRange?: string;
    contacts?: any;
    cfr?: any;
    source: string;
    createdAt?: Date;
  };
  // const [organization, setOrganization] = useState<Organization | null>(null);
  const [isEditing, setisEditing] = useState(false);

  const handleUpload = async (file: File): Promise<string> => {
    const { data } = await imagePreSignedUrl({
      fileName: file?.name,
      fileType: file?.type,
    });
    if (!data?.url) {
      showToast(
        "Error",
        "Could not process the upload. Please make sure the file is valid and the internet connection is stable",
        "error"
      );
      return "";
    }
    await fetch(data?.url, {
      method: data?.method,
      headers: { Accept: "application/json", "Content-Type": file.type },
      body: file,
    });
    // setImageKey(data?.key);
    return data.key;
  };

  const handleBack = () => {
    const prevUrl = theLocation.state?.from || '';

    if (prevUrl.includes("/merge")) {
      navigate("/home/organizations");
    } else {
      navigate(-1);
    }
  };

  const handleSaveChanges = async () => {
    try {
      // 1. Transform widgets to minimal, clean payload
      const widgets = widget.map((w) => ({
        widgetId: w.widgetId,
        x: w.x,
        y: w.y,
        w: w.w,
        h: w.h,
        ...(w.customTitle !== null && { customTitle: w.customTitle }),
      }));

      // 2. Call the API
      const response = await reorder({ data: { widgets: widgets }, scope }).unwrap();

      // 3. Handle success
      // Note: RTK Query's `unwrap()` throws on error, so if we reach here, it's success
      showToast("Success", "Layout updated successfully", "success");
      setIsManagingLayout(false);
      widgetRefetch();
      refetch();
    } catch (error: any) {
      // 4. Unified error handling
      const message =
        error?.data?.message ||
        error?.message ||
        "Failed to update layout. Please try again.";

      showToast("Error", message, "error");
      setIsManagingLayout(false);
    }
  };

  const confirmDelete = async () => {
      if (!id) return;
  
      setShowOrgDeletePopup(false);
  
      try {
        if (id) {
          const numericId = Number(id);
          await deleteOrganization(numericId).unwrap();
        }
  
        showToast('Organization Deleted', 'The organization is deleted.', 'success');
        navigate('/home/organizations');
        // if(from === '/merge'){
        //   navigate('/home/organizations')
        // } else {
        //   navigate(-1);
        // }
        
      } catch (error) {
        console.error('Delete failed:', error);
        showToast('Delete Failed', 'Failed to delete organization. Please try again.', 'error');
      } finally {

      }
    };

  // const handleCancel = () => {
  //   // setIsManagingLayout(false);
  //   gridRef.current?.onCancel();
  //   widgetRefetch();
  //   // setWidget(widgetData?.widgets);
  // }

  const handleCancel = () => {
    // 🔥 PEHLE state restore karein (component mount rakho)
    if (originalWidgets && originalWidgets.length > 0) {
      setWidget(originalWidgets);
    }

    // 🔥 PHIR grid ka onCancel call karein
    setTimeout(() => {
      gridRef.current?.onCancel();
      setIsManagingLayout(false);
    }, 0);

    // 🔥 End mein refetch (optional - agar server se fresh data chahiye)
    // widgetRefetch(); // Ye mat karein immediately, nahi to loading state aa jayega
  };

  const handleCloseBulkUpdateModal = () => {
    setShowBulkUpdateModal(false);
  };
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  useEffect(() => {
    if (!widgetLoading && !widgetFetching) {
      setHasLoadedOnce(true);
    }
  }, [widgetLoading, widgetFetching]);


  return (
    <Container theme={theme} className=" pt-0 " style={{ backgroundColor: 'transparent' }}>
      <div className="d-flex  justify-content-between align-items-center mt-4">
        <div className="d-flex  gap-2">
          <ArrowIcon
            className="cursor-pointer"
            onClick={handleBack}
            color={theme.CorporateTheme.colors.textSecondary}
          />
          <StyledText fontSize="16px">Back</StyledText>
        </div>
        {/* <div>
          <Breadcrumb items={breadcrumbItems} />
        </div> */}
        <div className="d-flex gap-2 mb-2">
          {/* <Button theme={theme} type="submit" $variant="add">
                    Edit Account
                  </Button> */}

          {/* <Breadcrumb items={breadcrumbItems} /> */}
          {/* <Button
            theme={theme}
            btnBg={theme?.CorporateTheme?.colors?.primary}
            color={theme?.CorporateTheme?.colors?.background}
            borderColor="none"
            type="button"
            $variant="customButton"
            className={`px-3`}

            onClick={() => setShowBulkUpdateModal(true)}
          >
            <PlusIcon color={theme?.CreateFormTheme?.colors?.background} />
            Add Fields
          </Button> */}
          <Button
            theme={theme}
            btnBg={theme?.CorporateTheme?.colors?.background}
            color={theme?.CorporateTheme?.colors?.headerColor}
            type="button"
            borderColor={theme?.CorporateTheme?.colors?.border}
            width="42px"
            $variant="customButton"
            className={`px-3`}
            btnPadding="1px !important"
            onClick={() => setShowOrgDeletePopup(true)}
          >
            <DeleteIcon />
            {/* Delete Organization */}
          </Button>
          {activeTab === 1 && (
            <>
              <Button
                theme={theme}
                btnBg={theme?.CorporateTheme?.colors?.count}
                color={theme?.CorporateTheme?.colors?.background}
                borderColor="none"
                type="button"
                $variant="customButton"
                className={`px-3`}

                onClick={() => {
                  if (isManagingLayout) {
                    handleSaveChanges();
                  }
                  setOriginalWidgets(widgetData?.widgets);
                  setIsManagingLayout(true);
                }}
              >
                {(isManagingLayout && reorderLoading) ? <LoadingSpinner color={theme?.CreateFormTheme?.colors?.background} size="18px" /> : <WidgetIcon color={theme?.CreateFormTheme?.colors?.background} />}
                {isManagingLayout ? "Save Changes" : "Manage Layout"}
              </Button>
              {isManagingLayout ? <Button
                theme={theme}
                btnBg={theme?.CorporateTheme?.colors?.primary}
                color={theme?.CorporateTheme?.colors?.background}
                borderColor="none"
                type="button"
                $variant="customButton"
                className={`px-3`}

                onClick={() => {

                  handleCancel();

                }}
              >
                {<CloseIcon color={theme?.CreateFormTheme?.colors?.background} />}
                Cancel Changes
              </Button> : null}

              <Button
                theme={theme}
                btnBg={theme?.CorporateTheme?.colors?.primary}
                color={theme?.CorporateTheme?.colors?.background}
                type="button"
                borderColor="none"

                $variant="customButton"
                className={`px-3`}
              >
                Account Setting
              </Button>
            </>
          )}

        </div>
      </div>
      <div
        className="overflow-y-auto"
        style={{
          height: "calc(100vh - 195px)",
        }}
      >
        <StyledOrganizationBanner theme={theme}>
          {loading ? (
            <SkeletonWrapper>
              <SkeletonCell
                style={{ width: "200px", height: "30px", marginBottom: "10px" }}
              />
              <SkeletonCell style={{ width: "100%", height: "200px" }} />
            </SkeletonWrapper>
          ) : (
            <>
              <OrganizationHeader 
                organizationData={organizationData?.data} 
                setShowAboutOrgModal={setShowAboutOrgModal} 
                updateOrgName={updateOrganizationNameOnly} 
                organization={organization} 
                handleUpload={handleUpload} 
                organizationName={organizationName} 
                setOrganizationName={setOrganizationName} 
                updateName={updateOrganizationImageOnly} 
                editName={editName} 
                seteditName={seteditName} 
                isLoading={isLoading} 
                loading={loading} 
                isLoadingName={isLoadingName} 
              />
            </>
          )}
          <Tabs tabs={tabs} onChangeTabs={onChangeTabs} />
        </StyledOrganizationBanner>
        {activeTab === 2 ? (
          <PendingJoinRequests organizationId={id} organizationName={organization?.name} />
        ) : (widgetLoading || widgetFetching || !hasLoadedOnce) ? (
          // 🔹 LOADING STATE
          <div className="d-flex flex-wrap gap-3 align-items-center justify-content-center">
            {Array(4).fill(null).map((_, i) => (
              <SkeletonCell
                key={i}
                style={{
                  width: "32%",
                  height: "250px",
                  marginBottom: "5px",
                  borderRadius: "8px",
                }}
              />
            ))}
          </div>
        ) : widget?.length === 0 ? (
          // 🔹 ZERO STATE
          <div className="d-flex flex-column align-items-center">
            <NoData
              title={"No Widget Found"}
              subtitle={"No widget available for this contact."}
              containerHeight={500}
            />
          </div>
        ) : (
          <OrganizationOverview
            ref={gridRef}
            loading={loading}
            editingPhase={isEditing}
            organization={organization}
            refetch={refetch}
            backUpWidgets={originalWidgets}
            widget={widget} setWidget={setWidget}
            isManagingLayout={isManagingLayout}
            setIsManagingLayout={setIsManagingLayout}
            widgetRefetch={widgetRefetch}
            scope={scope}
            userDataRefetch={refetch}
            refetchOrganizationData={organizationRefetch}
          />
        )
          /* {widget?.length > 0 ? <OrganizationOverview
            ref={gridRef}
            loading={loading}
            editingPhase={isEditing}
            organization={organization}
            refetch={refetch}
            backUpWidgets={originalWidgets}
            widget={widget} setWidget={setWidget}
            isManagingLayout={isManagingLayout}
            setIsManagingLayout={setIsManagingLayout}
          /> : null */
        }
      </div>
      {/* <AboutOrgModal prefillData={organizationData} show={showAboutOrgModal} onClose={handleCloseAboutOrgModal} recordIds={id ? [Number(id)] : []} refetch={organizationRefetch} userDetailsRefetch={refetch} /> */}
      {/* <BulkUpdateModal show={showBulkUpdateModal} onClose={handleCloseBulkUpdateModal} scope={scope} recordIds={id ? [Number(id)] : []} refetch={widgetRefetch} /> */}
      {showOrgDeletePopup &&
        <DeletePrompt onConfirm={confirmDelete} onCancel={() => setShowOrgDeletePopup(false)} />
      }

    </Container>
  );
};

export default OrganizationPreview;

const StyledOrganizationBanner = styled.div`
  background-color: ${({ theme }) => theme.CorporateTheme.colors?.bannerBg};
  border-radius: 4px;
  padding: 25px 25px 0px 35px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
`;
const StyledAboutBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
  min-width: 31%;
`;
export const StyledVr = styled.div`
  border-right: 1px solid ${({ theme }) => theme.CorporateTheme.colors.border};
  color: ${({ theme }) => theme.CorporateTheme.colors.border};
  height: 50px;
`;
export const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;
